import { map } from 'lodash'
import React from 'react'
import getSymbolFromCurrency from 'currency-symbol-map'
import './style.css'


class PopupPlan extends React.Component {
  render() {
    var p = this.props.plan
    var pd = p.planDetails[0]
    let featuredPlan = pd && pd.featurePlanIdentifier
    return (
      <div
        className={ `popup-plan ${ featuredPlan ? 'selected site-border-color': '' }` }>
        <div className="upper-section">
          <div className="title">{ pd.title || p.name }</div>
          <div className="desc1">{ pd.featurePlanIdentifier }</div>
          <div className="desc2">
            { getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}{ pd.recurringPaymentAmount }
          </div>
          <div className="points">
            { map( pd.featureDetails, (fd, i) => (
              <div className="point site-color-before" key={i}>
                { fd.textToDisplay }
              </div>
            )) }
          </div>
        </div>
        <div
          className={ 'button site-background-color' + (!featuredPlan ? ' inactive' : '') }
          onClick={ _ => this.props.onClick()} >
          { pd.callToAction || this.props.buttonText || 'Start Your Free Trial' }
        </div>
      </div>
    )
  }


}
export default PopupPlan;